import React, { FC } from 'react';
import { Link as ReactLink } from 'react-router';

import moment from 'moment';

import LanguageIcon from '@mui/icons-material/Language';
import Typography from '@mui/material/Typography';

import footerLogo from '@assets/logos/logo.png';

import Container from '@components/common/Container';
import Link from '@components/common/Link';

import { SOCIAL_LINKS } from '@constants/common/footer.constants';
import { PATH_INDEX } from '@constants/common/routes.constants';

import useStyles from './styles.module';

const CURRENT_YEAR = moment().year();

const Footer: FC = () => {
  const { classes } = useStyles();

  return (
    <footer className={classes.footer}>
      <Container className={classes.box}>
        <div className={classes.left}>
          <ReactLink to={PATH_INDEX}>
            <img
              src={footerLogo}
              className={classes.logo}
              alt="logo dexFinance"
            />
          </ReactLink>
        </div>
        <div className={classes.right}>
          <div className={classes.footerSocials}>
            {SOCIAL_LINKS.map(({ title, icon, path }) => (
              <Link
                key={`${title}-footer`}
                pathname={path}
                className={classes.icon}
                isNewTab
              >
                {icon}
              </Link>
            ))}
          </div>
          <Link
            pathname="https://dragonx.win/"
            variant="subtitle1"
            isNewTab
            color={(theme) => theme.palette.custom.text.light}
            className={classes.link}
          >
            <LanguageIcon fontSize="small" /> dragonx.win
          </Link>
          <Typography
            variant="body2"
            color={(theme) => theme.palette.custom.text.light}
          >
            © {CURRENT_YEAR} Dragon Bonds. All rights reserved.
          </Typography>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
